import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { SHADOW_SPREAD_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/shadow_spread';
import alpha from '../utils/alpha';
import blendColors from '../utils/blendColors';

const {
  COLORS,
  OPACITY,
} = Tokens;

const {
  OPACITY_0,
  OPACITY_06,
  OPACITY_12,
  OPACITY_24,
  OPACITY_38,
  OPACITY_54,
  OPACITY_76,
  OPACITY_87,
} = OPACITY;

const {
  BLACK,
  WHITE,
  TRANSPARENT,
  CANARY_YELLOW_10,
  CANARY_YELLOW_50,
  CANARY_YELLOW_100,
  CANARY_YELLOW_200,
  CANARY_YELLOW_300,
  CANARY_YELLOW_400,
  CANARY_YELLOW_500,
  NOKIA_BLUE_10,
  NOKIA_BLUE_50,
  NOKIA_BLUE_100,
  NOKIA_BLUE_200,
  NOKIA_BLUE_300,
  NOKIA_BLUE_400,
  NOKIA_BLUE_500,
  MIDNIGHT_BLUE_10,
  MIDNIGHT_BLUE_100,
  MIDNIGHT_BLUE_400,
  PITAYA_PINK_400,
  POPPY_RED_10,
  POPPY_RED_50,
  POPPY_RED_100,
  POPPY_RED_300,
  POPPY_RED_400,
  POPPY_RED_500,
  PUMPKIN_ORANGE_50,
  PUMPKIN_ORANGE_100,
  PUMPKIN_ORANGE_200,
  PUMPKIN_ORANGE_300,
  PUMPKIN_ORANGE_500,
  NEUTRAL_GREY_10,
  NEUTRAL_GREY_50,
  NEUTRAL_GREY_100,
  NEUTRAL_GREY_150,
  NEUTRAL_GREY_200,
  NEUTRAL_GREY_250,
  NEUTRAL_GREY_300,
  NEUTRAL_GREY_350,
  NEUTRAL_GREY_400,
  DARK_GREY_350,
  KINGFISHER_BLUE_10,
  KINGFISHER_BLUE_50,
  KINGFISHER_BLUE_100,
  KINGFISHER_BLUE_200,
  KINGFISHER_BLUE_300,
  KINGFISHER_BLUE_500,
  STEEL_TEAL_100,
  VIVID_VIOLET_300,
  VIVID_VIOLET_400,
  WARM_TAUPE_100,
  SCIENCE_BLUE_200,
  SCIENCE_BLUE_300,
  SCIENCE_BLUE_400,
  APPLE_GREEN_50,
  LIME_GREEN_10,
  LIME_GREEN_100,
  LIME_GREEN_200,
  LIME_GREEN_300,
  LIME_GREEN_400,
  LIME_GREEN_500,
  SEA_GREEN_100,
  SEA_GREEN_400,
  CERULEAN_BLUE_50,
  CERULEAN_BLUE_100,
  CERULEAN_BLUE_200,
  CERULEAN_BLUE_500,
  AMETHYST_PURPLE_300,
  BLUSH_PINK_50,
} = COLORS

const GLOBAL_TRANSPARENT = TRANSPARENT;

const PRIMARY_GLOBAL_BASE = NOKIA_BLUE_500;
const PRIMARY_GLOBAL_HOVER = alpha(WHITE, OPACITY_12);
const PRIMARY_GLOBAL_PRESSED = alpha(WHITE, OPACITY_24);
const PRIMARY_GLOBAL_FOCUS = KINGFISHER_BLUE_500;
const PRIMARY_GLOBAL_CONTENT = WHITE;
const PRIMARY_GLOBAL_DISABLED_CONTENT = NOKIA_BLUE_200;
const PRIMARY_GLOBAL_DISABLED_BACKGROUND = NEUTRAL_GREY_100;
const PRIMARY_GLOBAL_DIVIDER = TRANSPARENT;
const PRIMARY_GLOBAL_PLACEHOLDER = WHITE;
const PRIMARY_GLOBAL_LABEL = NOKIA_BLUE_50;
const PRIMARY_GLOBAL_ERROR_TEXT = POPPY_RED_400;
const PRIMARY_GLOBAL_TEXT = WHITE;
const PRIMARY_GLOBAL_HYPERLINK = SCIENCE_BLUE_400;

const SECONDARY_GLOBAL_BASE = WHITE;
const SECONDARY_GLOBAL_HOVER = alpha(BLACK, OPACITY_12);
const SECONDARY_GLOBAL_PRESSED = alpha(BLACK, OPACITY_24);
const SECONDARY_GLOBAL_FOCUS = KINGFISHER_BLUE_300;
const SECONDARY_GLOBAL_DISABLED_CONTENT = NEUTRAL_GREY_250;
const SECONDARY_GLOBAL_DISABLED_BACKGROUND = NEUTRAL_GREY_50;
const SECONDARY_GLOBAL_DIVIDER = NEUTRAL_GREY_100;
const INPUT_BORDER = NEUTRAL_GREY_300;
const SECONDARY_GLOBAL_PLACEHOLDER = NEUTRAL_GREY_300;
const SECONDARY_GLOBAL_LABEL = NEUTRAL_GREY_350;
const SECONDARY_GLOBAL_CONTENT = NEUTRAL_GREY_400;
const SECONDARY_GLOBAL_TEXT = NEUTRAL_GREY_400;
const SECONDARY_GLOBAL_ERROR_TEXT = POPPY_RED_400;
const SECONDARY_GLOBAL_PRESSED_CONTENT = NEUTRAL_GREY_350;
const SECONDARY_GLOBAL_BACKGROUND = TRANSPARENT;
const SECONDARY_GLOBAL_SELECTED = KINGFISHER_BLUE_10;
const SECONDARY_GLOBAL_DISABLED_TEXT = NEUTRAL_GREY_250;

const SECONDARY_BUTTON_CONTENT = NOKIA_BLUE_500;

const DATAGRID_BASE = WHITE;
const DATAGRID_HOVER = alpha(BLACK, OPACITY_06);
const DATAGRID_PRESSED = alpha(BLACK, OPACITY_54);
const DATAGRID_PRESSED_TEXT = NEUTRAL_GREY_400;
const DATAGRID_FOCUS = alpha(BLACK, OPACITY_12);
const DATAGRID_DISABLED_CONTENT = TRANSPARENT;
const DATAGRID_DISABLED_BACKGROUND = TRANSPARENT;
const DATAGRID_DIVIDER = NEUTRAL_GREY_100;
const DATAGRID_PLACEHOLDER = NEUTRAL_GREY_300;
const DATAGRID_LABEL = NEUTRAL_GREY_350;
const DATAGRID_TEXT = NEUTRAL_GREY_400;
const DATAGRID_ERROR_BACKGROUND = POPPY_RED_10;
const DATAGRID_ERROR_TEXT = POPPY_RED_300;
const DATAGRID_SELECTED = KINGFISHER_BLUE_10;
const DATAGRID_SELECTED_HOVER = alpha(KINGFISHER_BLUE_300, OPACITY_06);
const DATAGRID_SELECTED_PRESSED = alpha(KINGFISHER_BLUE_300, OPACITY_24);
const DATAGRID_SELECTED_FOCUS = alpha(KINGFISHER_BLUE_300, OPACITY_12);
const DATAGRID_HEADER_BASE = NEUTRAL_GREY_10;
const DATAGRID_INPUT_BORDER = NEUTRAL_GREY_350;
const CTA_DISABLED_CONTENT = NEUTRAL_GREY_250;

const FILEUPLOAD_ACTIVE = KINGFISHER_BLUE_10;
const SLIDER_TRACK = NEUTRAL_GREY_100;

const STATUS_SUCCESS = LIME_GREEN_200;
const STATUS_CRITICAL	= POPPY_RED_400;
const STATUS_MAJOR = PUMPKIN_ORANGE_300;
const STATUS_MINOR = CANARY_YELLOW_300;
const STATUS_WARNING = KINGFISHER_BLUE_200;
const STATUS_CLEARED = SEA_GREEN_100;
const STATUS_KPI_CONDITIONAL = STEEL_TEAL_100;
const STATUS_KPI_INFO = NEUTRAL_GREY_250;
const STATUS_FAULT = NEUTRAL_GREY_200;
const STATUS_KPI_INTERMEDIATE = WARM_TAUPE_100;
const STATUS_CONTENT = NEUTRAL_GREY_400;
const STATUS_MAINTENANCE = VIVID_VIOLET_300;
const STATUS_INSTALLED = LIME_GREEN_300;
const STATUS_CRITICAL_OFF = POPPY_RED_100;
const STATUS_MAJOR_OFF = PUMPKIN_ORANGE_100;
const STATUS_MINOR_OFF = CANARY_YELLOW_100;
const STATUS_WARNING_OFF = KINGFISHER_BLUE_100;
const STATUS_CRITICAL_ON = POPPY_RED_400;
const STATUS_MAJOR_ON = PUMPKIN_ORANGE_500;
const STATUS_MINOR_ON = CANARY_YELLOW_500;
const STATUS_WARNING_ON = KINGFISHER_BLUE_500;
const STATUS_CRITICAL_DISABLED = POPPY_RED_50;
const STATUS_MAJOR_DISABLED = PUMPKIN_ORANGE_50;
const STATUS_MINOR_DISABLED = CANARY_YELLOW_50;
const STATUS_WARNING_DISABLED = KINGFISHER_BLUE_50;

const LIST_FOCUS = alpha(BLACK, OPACITY_12);
const LIST_HOVER = alpha(BLACK, OPACITY_06);
const LIST_SELECTED = KINGFISHER_BLUE_10;
const LIST_DISABLED = alpha(DARK_GREY_350, OPACITY_38);
const LIST_TEXT_SELECTED = NOKIA_BLUE_300;
const LIST_ITEM_ACTIVE = alpha(BLACK, OPACITY_12);

const LIST_ITEM_BASE = alpha(WHITE, OPACITY_0);
const LIST_ITEM_FOCUS = alpha(BLACK, OPACITY_12);
const LIST_ITEM_SELECTED_HOVER = alpha(KINGFISHER_BLUE_300, OPACITY_06);
const LIST_ITEM_SELECTED_FOCUS = alpha(KINGFISHER_BLUE_300, OPACITY_12);
const LIST_ITEM_HOVER = alpha(BLACK, OPACITY_06);
const LIST_BADGE_HOVER_BORDER = "#ebebeb";
const LIST_ITEM_SELECTED = KINGFISHER_BLUE_10;
const LIST_ITEM_DISABLED = NEUTRAL_GREY_50;
const LIST_ITEM_PRESSED = alpha(KINGFISHER_BLUE_300, OPACITY_24);
const LIST_ITEM_UNREAD = alpha(BLACK, OPACITY_12);
const LIST_ITEM_PRESSED_CONTENT = NEUTRAL_GREY_350;
const LIST_HEADER_BACKGROUND = NEUTRAL_GREY_50;

const STEPFORM_BASE = NEUTRAL_GREY_10;
const STEPFORM_HOVER = alpha(BLACK, OPACITY_06);
const STEPFORM_PRESSED = alpha(BLACK, OPACITY_24);
const STEPFORM_ERROR_BACKGROUND = POPPY_RED_10;
const STEPFORM_SELECTED_BACKGROUND = KINGFISHER_BLUE_10;
const STEPFORM_SELECTED_HOVER = alpha(KINGFISHER_BLUE_300, OPACITY_06);;
const STEPFORM_SELECTED_TEXT = NOKIA_BLUE_300;
const STEPFORM_ACTIVE = NOKIA_BLUE_300;
const STEPFORM_COMPLETED_DISABLED = NOKIA_BLUE_50;
const STEPFORM_FUTURE = NEUTRAL_GREY_250;
const STEPFORM_WARNING = CANARY_YELLOW_300;
const STEPFORM_DISABLED_WARNING_ICON = CANARY_YELLOW_50;
const STEPFORM_ERROR_ICON = POPPY_RED_400;
const STEPFORM_PRESSED_ERROR_ICON = POPPY_RED_500;
const STEPFORM_DISABLED_ERROR_ICON = POPPY_RED_50;
const STEPFORM_TEXT = BLACK;
const STEPFORM_PRESSED_TEXT = NOKIA_BLUE_500;

const CALENDAR_RANGE_TITLE = NOKIA_BLUE_400;

const TABS_BASE = TRANSPARENT;
const TABS_HOVER = alpha(BLACK, OPACITY_06);
const TABS_HOVER_SOLID = '#F0F0F09C';
const TABS_PRESSED = alpha(BLACK, OPACITY_24);
const TABS_PRESSED_TEXT = NOKIA_BLUE_500;

const TREE_BASE = alpha(WHITE, OPACITY_0);
const TREE_SELECTED_HOVER = alpha(KINGFISHER_BLUE_300, OPACITY_06);
const TREE_HOVER = alpha(BLACK, OPACITY_06);
const TREE_SELECTED = KINGFISHER_BLUE_10;
const TREE_DISABLED = NEUTRAL_GREY_50;
const TREE_PRESSED =  alpha(KINGFISHER_BLUE_300, OPACITY_24);

const TEXT_SELECTION = alpha(KINGFISHER_BLUE_300, OPACITY_24);
const TEXT_SELECTION_FOCUS = alpha(VIVID_VIOLET_300, OPACITY_24);

const EXPANSION_PANEL_BASE = TRANSPARENT;
const EXPANSION_PANEL_SELECTED_HOVER =  alpha(KINGFISHER_BLUE_300, OPACITY_06);
const EXPANSION_PANEL_HOVER = alpha(BLACK, OPACITY_06);
const EXPANSION_PANEL_SELECTED = KINGFISHER_BLUE_10;
const EXPANSION_PANEL_DISABLED = NEUTRAL_GREY_50;
const EXPANSION_PANEL_PRESSED = alpha(KINGFISHER_BLUE_300, OPACITY_24);

const CHIP_BASE = NEUTRAL_GREY_100;
const CHIP_CONTENT = BLACK;
const CHIP_SECONDARY_CONTENT = BLACK;
const CHIP_ICON = NEUTRAL_GREY_400;
const CHIP_FOCUS = alpha(BLACK, OPACITY_12);
const CHIP_HOVER = alpha(BLACK, OPACITY_06);
const CHIP_PRESSED = alpha(BLACK, OPACITY_24);
const CHIP_DISABLED = NEUTRAL_GREY_50;
const CHIP_DISABLED_CONTENT = NEUTRAL_GREY_250;
const CHIP_SELECTED = KINGFISHER_BLUE_10;
const CHIP_SELECTED_HOVER = alpha(KINGFISHER_BLUE_300, OPACITY_06);
const CHIP_SELECTED_FOCUS = alpha(KINGFISHER_BLUE_300, OPACITY_12);
const CHIP_INFO = MIDNIGHT_BLUE_10;
const CHIP_ERROR_BACKGROUND = POPPY_RED_10;
const CHIP_ERROR_SELECTED_BACKGROUND = POPPY_RED_50;
const CHIPS_PRIMARY_FOCUS = MIDNIGHT_BLUE_400;

const HYPERLINK_DISABLED = NOKIA_BLUE_100;
const HYPERLINK_PRESSED = NOKIA_BLUE_300;

const INPUT_HOVER = alpha(BLACK, OPACITY_76);
const TOOLTIP_TEXT = WHITE;
const TOOLTIP_BACKGROUND = alpha(BLACK, OPACITY_76);

const QUERY_BACKGROUND_ON = NEUTRAL_GREY_100;
const QUERY_BACKGROUND_FOCUS = alpha(KINGFISHER_BLUE_300, OPACITY_24);

const TOGGLE_GROUP_HOVER_ON = alpha(BLACK, OPACITY_06);
const TOGGLEGROUP_BACKGROUND_ON = NEUTRAL_GREY_100;
const TOGGLEGROUP_HOVER_ON = alpha(BLACK, OPACITY_06);
const TOGGLEGROUP_DIVIDER_ON = NEUTRAL_GREY_150;
const TOGGLEGROUP_CONTENT_ON = NEUTRAL_GREY_400;
const TOGGLEGROUP_CONTENT_OFF = NEUTRAL_GREY_350;
const TOGGLEGROUP_CONTENT_PRESSED_ON = BLACK;
const TOGGLEGROUP_CONTENT_PRESSED_OFF = BLACK;
const TOGGLE_CONTENT_ON = WHITE;
const TOGGLE_BACKGROUND_ON = NOKIA_BLUE_300;
const TOGGLE_FOCUS_ON = KINGFISHER_BLUE_100;
const OR_TOGGLE_BACKGROUND = NEUTRAL_GREY_200;

const PROGRESS_INDICATOR = SCIENCE_BLUE_300;
const PROGRESS_INDICATOR_TRACK = NEUTRAL_GREY_100;
const PROGRESS_INDICATOR_DETERMINATE = SCIENCE_BLUE_400;

const AVATAR_DARKBLUE = NOKIA_BLUE_300;
const AVATAR_LIGHTBLUE = CERULEAN_BLUE_50;
const AVATAR_DARKPURPLE = AMETHYST_PURPLE_300;
const AVATAR_LIGHTPURPLE = VIVID_VIOLET_400;
const AVATAR_PINK = BLUSH_PINK_50;
const AVATAR_ORANGE = PUMPKIN_ORANGE_200;
const AVATAR_YELLOW = CANARY_YELLOW_400;
const AVATAR_BLUE = KINGFISHER_BLUE_500;
const AVATAR_GREEN = APPLE_GREEN_50;
const AVATAR_CONTENT = BLACK;

const APPBANNER_PRIMARY_FOCUS = alpha(WHITE, OPACITY_76);
const APPBANNER_PRIMARY_CONTENT = WHITE;
const APPBANNER_SECONDARY_CONTENT = alpha(WHITE, OPACITY_76);
const APPBANNER_BACKGROUND = NOKIA_BLUE_400;
const APPBANNER_BADGE_HOVER_BORDER = "#2C4E87";
const APPBANNER_BADGE_PPRESSED_BORDER = "#6B7FA7";
const APPBANNER_DIVIDER = alpha(WHITE, OPACITY_54);
const APPBANNER_BADGE = blendColors(WHITE, alpha(POPPY_RED_50, OPACITY_87));
const APPBANNER_SHADOW_SPREAD = SHADOW_SPREAD_4;
const APPBANNER_PRESSED = alpha(WHITE, OPACITY_24);

const CLI_BACKGROUND = NEUTRAL_GREY_400;
const CLI_TEXT = WHITE;
const CLI_BACKGROUND_TEXT = KINGFISHER_BLUE_500;
const CLI_CURSOR = SCIENCE_BLUE_200;
const CLI_ICON = WHITE;
const CLI_BACKGROUND_PAG = NEUTRAL_GREY_350;

const SKELETON_BASE = alpha(BLACK, OPACITY_06);
const SKELETON_GRADIENT = alpha(WHITE, OPACITY_76);

const SNACKBAR_BACKGROUND = NEUTRAL_GREY_400;
const SNACKBAR_TEXT = WHITE;
const SNACKBAR_HYPERLINK = CERULEAN_BLUE_100;
const SNACKBAR_PROGRESS_INDICATOR_DETERMINATE = SCIENCE_BLUE_200;
const SNACKBAR_PROGRESS_INDICATOR = CERULEAN_BLUE_100;

const FEEDBACK_INFO_BACKGROUND = NOKIA_BLUE_10;
const FEEDBACK_ERROR_BACKGROUND = POPPY_RED_10;
const FEEDBACK_WARNING_BACKGROUND = CANARY_YELLOW_10;
const FEEDBACK_SUCCESS_BACKGROUND = LIME_GREEN_10;
const FEEDBACK_SUCCESS = LIME_GREEN_500;
const FEEDBACK_HYPERLINK = SCIENCE_BLUE_400;
const FEEDBACK_OVERLAY = alpha(BLACK, OPACITY_54);

const OVERLAY_TOP_DIVIDER = NEUTRAL_GREY_100;

const FAB_PRIMARY_BACKGROUND = CERULEAN_BLUE_200;
const FAB_CONTENT = NEUTRAL_GREY_400;
const FAB_PRIMARY_FOCUS = NOKIA_BLUE_300;
const FAB_HOVER = alpha(WHITE, OPACITY_12);
const FAB_PRESSED = alpha(WHITE, OPACITY_24);
const FAB_SECONDARY_BACKGROUND = CANARY_YELLOW_200;
const FAB_CLOSE_BACKGROUND = POPPY_RED_100;
const FAB_CLOSE_CONTENT = NEUTRAL_GREY_400;
const FAB_MINI_BACKGROUND = WHITE;

const SWITCH_PRIMARY_OFF_TRACK = alpha(NEUTRAL_GREY_300, OPACITY_38);
const SWITCH_PRIMARY_OFF_KNOB = NEUTRAL_GREY_300;
const SWITCH_PRIMARY_OFF_HOVER = alpha(NEUTRAL_GREY_300, OPACITY_12);
const SWITCH_PRIMARY_OFF_PRESSED = alpha(NEUTRAL_GREY_300, OPACITY_24);
const SWITCH_PRIMARY_OFF_DISABLED_KNOB =  NEUTRAL_GREY_200;
const SWITCH_PRIMARY_ON_TRACK = alpha(NOKIA_BLUE_300, OPACITY_38);
const SWITCH_PRIMARY_ON_KNOB = NOKIA_BLUE_300;
const SWITCH_PRIMARY_ON_HOVER = alpha(NOKIA_BLUE_300, OPACITY_12);
const SWITCH_PRIMARY_ON_PRESSED = alpha(NOKIA_BLUE_300, OPACITY_24);
const SWITCH_PRIMARY_ON_DISABLED_KNOB = NOKIA_BLUE_100;
const SWITCH_SECONDARY_OFF_TRACK = alpha(POPPY_RED_300, OPACITY_38);
const SWITCH_SECONDARY_OFF_KNOB = POPPY_RED_300;
const SWITCH_SECONDARY_OFF_HOVER = alpha(POPPY_RED_300, OPACITY_12);
const SWITCH_SECONDARY_OFF_PRESSED = alpha(POPPY_RED_300, OPACITY_24);
const SWITCH_SECONDARY_OFF_DISABLED_KNOB = POPPY_RED_100;
const SWITCH_SECONDARY_ON_TRACK = alpha(LIME_GREEN_400, OPACITY_38);
const SWITCH_SECONDARY_ON_KNOB = LIME_GREEN_500;
const SWITCH_SECONDARY_ON_HOVER = alpha(LIME_GREEN_400, OPACITY_24);
const SWITCH_SECONDARY_ON_PRESSED = alpha(LIME_GREEN_400, OPACITY_24);
const SWITCH_SECONDARY_ON_DISABLED_KNOB = LIME_GREEN_100;

// APPLICATION ICONS
const ASSURE_AND_OPTIMIZE = LIME_GREEN_500;
const ADMINISTRATION = NOKIA_BLUE_300;
const AUTOMATE = MIDNIGHT_BLUE_100;
const CARE = CERULEAN_BLUE_500;
const INSIGHTS = PUMPKIN_ORANGE_500;
const INVENTORY = PITAYA_PINK_400;
const MONITORING = POPPY_RED_300;
const OPTICAL = KINGFISHER_BLUE_500;
const ORCHESTRATE_AND_FULFILL = AMETHYST_PURPLE_300;
const SAM = SEA_GREEN_400;
const SECURITY = NEUTRAL_GREY_350;
const USER_ASSISTANCE = CANARY_YELLOW_500;

const BADGE_BLUE= KINGFISHER_BLUE_500;
const BADGE_GREEN = LIME_GREEN_500;
const BADGE_GREY =  NEUTRAL_GREY_300;

const BREADCRUMB_PRESSED_CONTENT = BLACK;

const EXPRESSION_NORMAL = NOKIA_BLUE_300;
const EXPRESSION_FOCUS = KINGFISHER_BLUE_500;

const CHECKBOX_CHECKED = NOKIA_BLUE_300;
const RADIOBUTTON_CHECKED = NOKIA_BLUE_300;

const STATUSBAR_INPUT_BORDER = SCIENCE_BLUE_300;

const STICKY_HEADER = WHITE;
const STICKY_HEADER_HOVER = NEUTRAL_GREY_50;
const STICKY_HEADER_ACTIVE = NEUTRAL_GREY_100;

const NAV_CLOSE_CONTENT = NEUTRAL_GREY_100;
const NAV_CLOSE_HOVER = alpha(NEUTRAL_GREY_100, OPACITY_12);

const NOKIA_LOGO_BLUE = NOKIA_BLUE_300;
const NOKIA_LOGO_WHITE = WHITE;

const BACKGROUND_0 = WHITE;
const BACKGROUND_1 = WHITE;
const BACKGROUND_2 = WHITE;
const BACKGROUND_3 = WHITE;
const BACKGROUND_4 = WHITE;
const BACKGROUND_6 = WHITE;
const BACKGROUND_8 = WHITE;
const BACKGROUND_9 = WHITE;
const BACKGROUND_12 = WHITE;
const BACKGROUND_16 = WHITE;
const BACKGROUND_24 = WHITE;
const BACKGROUND_0_DARK = NEUTRAL_GREY_10;
const BACKGROUND_1_DARK = NEUTRAL_GREY_10;
const BACKGROUND_2_DARK = NEUTRAL_GREY_10;
const BACKGROUND_3_DARK = NEUTRAL_GREY_10;
const BACKGROUND_4_DARK = NEUTRAL_GREY_10;
const BACKGROUND_6_DARK = NEUTRAL_GREY_10;
const BACKGROUND_8_DARK = NEUTRAL_GREY_10;
const BACKGROUND_9_DARK = NEUTRAL_GREY_10;
const BACKGROUND_12_DARK = NEUTRAL_GREY_10;
const BACKGROUND_16_DARK = NEUTRAL_GREY_10;
const BACKGROUND_24_DARK = NEUTRAL_GREY_10;
const SHADOW_1 = alpha(BLACK, OPACITY_12);
const SHADOW_2 = alpha(BLACK, OPACITY_24);

export {
  PRIMARY_GLOBAL_BASE,
  PRIMARY_GLOBAL_HOVER,
  PRIMARY_GLOBAL_PRESSED,
  PRIMARY_GLOBAL_FOCUS,
  PRIMARY_GLOBAL_CONTENT,
  PRIMARY_GLOBAL_DISABLED_CONTENT,
  PRIMARY_GLOBAL_DISABLED_BACKGROUND,
  PRIMARY_GLOBAL_DIVIDER,
  PRIMARY_GLOBAL_PLACEHOLDER,
  PRIMARY_GLOBAL_LABEL,
  PRIMARY_GLOBAL_ERROR_TEXT,
  PRIMARY_GLOBAL_TEXT,
  PRIMARY_GLOBAL_HYPERLINK,

  SECONDARY_GLOBAL_BASE,
  SECONDARY_GLOBAL_HOVER,
  SECONDARY_GLOBAL_PRESSED,
  SECONDARY_GLOBAL_FOCUS,
  SECONDARY_GLOBAL_DISABLED_CONTENT,
  SECONDARY_GLOBAL_DISABLED_BACKGROUND,
  SECONDARY_GLOBAL_DIVIDER,
  INPUT_BORDER,
  SECONDARY_GLOBAL_PLACEHOLDER,
  SECONDARY_GLOBAL_LABEL,
  SECONDARY_GLOBAL_CONTENT,
  SECONDARY_GLOBAL_TEXT,
  SECONDARY_GLOBAL_ERROR_TEXT,
  SECONDARY_GLOBAL_PRESSED_CONTENT,
  SECONDARY_GLOBAL_BACKGROUND,
  SECONDARY_GLOBAL_SELECTED,
  SECONDARY_GLOBAL_DISABLED_TEXT,

  SECONDARY_BUTTON_CONTENT,

  DATAGRID_BASE,
  DATAGRID_HOVER,
  DATAGRID_PRESSED,
  DATAGRID_PRESSED_TEXT,
  DATAGRID_FOCUS,
  DATAGRID_DISABLED_CONTENT,
  DATAGRID_DISABLED_BACKGROUND,
  DATAGRID_DIVIDER,
  DATAGRID_PLACEHOLDER,
  DATAGRID_LABEL,
  DATAGRID_TEXT,
  DATAGRID_ERROR_BACKGROUND,
  DATAGRID_ERROR_TEXT,
  DATAGRID_SELECTED,
  DATAGRID_SELECTED_HOVER,
  DATAGRID_SELECTED_PRESSED,
  DATAGRID_SELECTED_FOCUS,
  DATAGRID_HEADER_BASE,
  DATAGRID_INPUT_BORDER,

  CTA_DISABLED_CONTENT,

  FILEUPLOAD_ACTIVE,

  STATUS_SUCCESS,

  HYPERLINK_DISABLED,
  HYPERLINK_PRESSED,

  SLIDER_TRACK,
  
  STATUS_CRITICAL,
  STATUS_MAJOR,
  STATUS_MINOR,
  STATUS_WARNING,
  STATUS_CLEARED,
  STATUS_KPI_CONDITIONAL,
  STATUS_KPI_INFO,
  STATUS_FAULT,
  STATUS_KPI_INTERMEDIATE,
  STATUS_CONTENT,
  STATUS_MAINTENANCE,
  STATUS_INSTALLED,
  STATUS_CRITICAL_OFF,
  STATUS_MAJOR_OFF,
  STATUS_MINOR_OFF,
  STATUS_WARNING_OFF,
  STATUS_CRITICAL_ON,
  STATUS_MAJOR_ON,
  STATUS_MINOR_ON,
  STATUS_WARNING_ON,
  STATUS_CRITICAL_DISABLED,
  STATUS_MAJOR_DISABLED,
  STATUS_MINOR_DISABLED,
  STATUS_WARNING_DISABLED,

  LIST_FOCUS,
  LIST_HOVER,
  LIST_SELECTED,
  LIST_DISABLED,

  CALENDAR_RANGE_TITLE,
  LIST_ITEM_BASE,
  LIST_ITEM_FOCUS,
  LIST_ITEM_SELECTED_HOVER,
  LIST_ITEM_SELECTED_FOCUS,
  LIST_ITEM_HOVER,
  LIST_BADGE_HOVER_BORDER,
  LIST_ITEM_SELECTED,
  LIST_ITEM_DISABLED,
  LIST_ITEM_PRESSED,
  LIST_ITEM_UNREAD,
  LIST_ITEM_PRESSED_CONTENT,
  LIST_HEADER_BACKGROUND,
  LIST_TEXT_SELECTED,
  LIST_ITEM_ACTIVE,

  STEPFORM_BASE,
  STEPFORM_HOVER,
  STEPFORM_PRESSED,
  STEPFORM_ERROR_BACKGROUND,
  STEPFORM_SELECTED_BACKGROUND,
  STEPFORM_SELECTED_HOVER,
  STEPFORM_SELECTED_TEXT,
  STEPFORM_ACTIVE,
  STEPFORM_COMPLETED_DISABLED,
  STEPFORM_FUTURE,
  STEPFORM_WARNING,
  STEPFORM_DISABLED_WARNING_ICON,
  STEPFORM_ERROR_ICON,
  STEPFORM_PRESSED_ERROR_ICON,
  STEPFORM_DISABLED_ERROR_ICON,
  STEPFORM_TEXT,
  STEPFORM_PRESSED_TEXT,

  TABS_BASE,
  TABS_HOVER,
  TABS_HOVER_SOLID,
  TABS_PRESSED,
  TABS_PRESSED_TEXT,

  TEXT_SELECTION,
  TEXT_SELECTION_FOCUS,
  
  TREE_BASE,
  TREE_HOVER,
  TREE_SELECTED,
  TREE_SELECTED_HOVER,
  TREE_DISABLED,
  TREE_PRESSED,

  EXPANSION_PANEL_BASE,
  EXPANSION_PANEL_SELECTED_HOVER,
  EXPANSION_PANEL_HOVER,
  EXPANSION_PANEL_SELECTED,
  EXPANSION_PANEL_DISABLED,
  EXPANSION_PANEL_PRESSED,

  CHIP_BASE,
  CHIP_CONTENT,
  CHIP_SECONDARY_CONTENT,
  CHIP_ICON,
  CHIP_FOCUS,
  CHIP_HOVER,
  CHIP_PRESSED,
  CHIP_DISABLED,
  CHIP_DISABLED_CONTENT,
  CHIP_SELECTED,
  CHIP_SELECTED_HOVER,
  CHIP_SELECTED_FOCUS,
  CHIP_INFO,
  CHIP_ERROR_BACKGROUND,
  CHIP_ERROR_SELECTED_BACKGROUND,
  CHIPS_PRIMARY_FOCUS,

  INPUT_HOVER,

  TOOLTIP_TEXT,
  TOOLTIP_BACKGROUND,

  QUERY_BACKGROUND_ON,
  QUERY_BACKGROUND_FOCUS,

  TOGGLE_GROUP_HOVER_ON,
  PROGRESS_INDICATOR,
  PROGRESS_INDICATOR_TRACK,
  PROGRESS_INDICATOR_DETERMINATE,
  AVATAR_DARKBLUE,
  AVATAR_LIGHTBLUE,
  AVATAR_DARKPURPLE,
  AVATAR_LIGHTPURPLE,
  AVATAR_PINK,
  AVATAR_ORANGE,
  AVATAR_YELLOW,
  AVATAR_BLUE,
  AVATAR_GREEN,
  AVATAR_CONTENT,
  APPBANNER_PRIMARY_FOCUS,
  APPBANNER_PRIMARY_CONTENT,
  APPBANNER_SECONDARY_CONTENT,
  APPBANNER_BACKGROUND,
  APPBANNER_BADGE_HOVER_BORDER,
  APPBANNER_BADGE_PPRESSED_BORDER,
  APPBANNER_DIVIDER,
  APPBANNER_BADGE,
  APPBANNER_SHADOW_SPREAD,
  APPBANNER_PRESSED,
  GLOBAL_TRANSPARENT,
  CLI_BACKGROUND,
  CLI_TEXT,
  CLI_BACKGROUND_TEXT,
  CLI_CURSOR,
  CLI_ICON,
  CLI_BACKGROUND_PAG,
  SNACKBAR_BACKGROUND,
  SNACKBAR_TEXT,
  SNACKBAR_HYPERLINK,
  SNACKBAR_PROGRESS_INDICATOR_DETERMINATE,
  SNACKBAR_PROGRESS_INDICATOR,
  FEEDBACK_INFO_BACKGROUND,
  FEEDBACK_ERROR_BACKGROUND,
  FEEDBACK_WARNING_BACKGROUND,
  FEEDBACK_SUCCESS_BACKGROUND,
  FEEDBACK_HYPERLINK,
  FEEDBACK_OVERLAY,
  FEEDBACK_SUCCESS,
  OVERLAY_TOP_DIVIDER,
  TOGGLEGROUP_BACKGROUND_ON,
  TOGGLEGROUP_HOVER_ON,
  TOGGLEGROUP_DIVIDER_ON,
  TOGGLEGROUP_CONTENT_ON,
  TOGGLEGROUP_CONTENT_OFF,
  TOGGLEGROUP_CONTENT_PRESSED_ON,
  TOGGLEGROUP_CONTENT_PRESSED_OFF,
  TOGGLE_CONTENT_ON,
  TOGGLE_BACKGROUND_ON,
  TOGGLE_FOCUS_ON,
  OR_TOGGLE_BACKGROUND,
  FAB_PRIMARY_BACKGROUND ,
  FAB_CONTENT,
  FAB_PRIMARY_FOCUS ,
  FAB_HOVER,
  FAB_PRESSED,
  FAB_SECONDARY_BACKGROUND,
  FAB_CLOSE_BACKGROUND,
  FAB_CLOSE_CONTENT,
  FAB_MINI_BACKGROUND,
  SWITCH_PRIMARY_OFF_TRACK,
  SWITCH_PRIMARY_OFF_KNOB,
  SWITCH_PRIMARY_OFF_HOVER,
  SWITCH_PRIMARY_OFF_PRESSED,
  SWITCH_PRIMARY_OFF_DISABLED_KNOB,
  SWITCH_PRIMARY_ON_TRACK,
  SWITCH_PRIMARY_ON_KNOB,
  SWITCH_PRIMARY_ON_HOVER,
  SWITCH_PRIMARY_ON_PRESSED,
  SWITCH_PRIMARY_ON_DISABLED_KNOB,
  SWITCH_SECONDARY_OFF_TRACK,
  SWITCH_SECONDARY_OFF_KNOB,
  SWITCH_SECONDARY_OFF_HOVER,
  SWITCH_SECONDARY_OFF_PRESSED,
  SWITCH_SECONDARY_OFF_DISABLED_KNOB,
  SWITCH_SECONDARY_ON_TRACK,
  SWITCH_SECONDARY_ON_KNOB,
  SWITCH_SECONDARY_ON_HOVER,
  SWITCH_SECONDARY_ON_PRESSED,
  SWITCH_SECONDARY_ON_DISABLED_KNOB,
  ASSURE_AND_OPTIMIZE,
  ADMINISTRATION,
  AUTOMATE,
  CARE,
  INSIGHTS,
  INVENTORY,
  MONITORING,
  OPTICAL,
  ORCHESTRATE_AND_FULFILL,
  SAM,
  SECURITY,
  USER_ASSISTANCE,
  BADGE_BLUE,
  BADGE_GREEN,
  BADGE_GREY,
  BREADCRUMB_PRESSED_CONTENT,
  EXPRESSION_NORMAL,
  EXPRESSION_FOCUS,
  CHECKBOX_CHECKED,
  RADIOBUTTON_CHECKED,
  STATUSBAR_INPUT_BORDER,
  STICKY_HEADER,
  STICKY_HEADER_HOVER,
  STICKY_HEADER_ACTIVE,
  NAV_CLOSE_CONTENT,
  NAV_CLOSE_HOVER,
  NOKIA_LOGO_BLUE,
  NOKIA_LOGO_WHITE,
  BACKGROUND_0,
  BACKGROUND_1,
  BACKGROUND_2,
  BACKGROUND_3,
  BACKGROUND_4,
  BACKGROUND_6,
  BACKGROUND_8,
  BACKGROUND_9,
  BACKGROUND_12,
  BACKGROUND_16,
  BACKGROUND_24,
  BACKGROUND_0_DARK,
  BACKGROUND_1_DARK,
  BACKGROUND_2_DARK,
  BACKGROUND_3_DARK,
  BACKGROUND_4_DARK,
  BACKGROUND_6_DARK,
  BACKGROUND_8_DARK,
  BACKGROUND_9_DARK,
  BACKGROUND_12_DARK,
  BACKGROUND_16_DARK,
  BACKGROUND_24_DARK,
  SHADOW_1,
  SHADOW_2,
  SKELETON_BASE,
  SKELETON_GRADIENT,
};